module.exports = __webpack_public_path__ + "static/lifetimeCover-a046fc60dbdff95bec66572ff1a90fd1.jpg";